import {useAuth0} from "@auth0/auth0-react";
import React, {useEffect, useState} from "react";
import {PageLayout} from "../../components/page-layout";
import { getCompanies, getCompanyForSiret, saveCseElection } from "../../services/admin.service";
import {useForm} from "react-hook-form";
import {toast} from 'react-toastify';
import { DropdownButton } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";

export const PageCSE = () => {
    const [loading, setLoading] = useState(false);

    const {getAccessTokenSilently} = useAuth0();

    const [results, setResults] = useState(null);

    const [options, setOptions] = useState([]);

    const {register, handleSubmit, setValue, formState: {errors}} = useForm();
    const onSubmit = data => sendCseElection(data)
    const sendCseElection = async (data) => {
        let electionId = data.election_round_one || data.election_round_two;
        if (electionId || data.carency_round_one || data.carency_round_two) {
            setLoading(true);
            const accessToken = await getAccessTokenSilently();
            const form = {
                "siret": data.siret,
                "name": data.name,
                "address1": data.address1,
                "address2": data.address2,
                "postalCode": data.postalCode,
                "city": data.city,
                "contactFirstName": data.contactFirstName,
                "contactLastName": data.contactLastName,
                "contactRole": data.contactRole,
                "contactEmail": data.contactEmail,
                "contactPhone": data.contactPhone,
                "colleges": data.colleges,
                "lastElection": data.lastElection,
                "idcc": data.idcc,
                "seats": data.seats,
                "is_partial": data.is_partial,
                "college": data.college,
                "has_workers": data.has_workers,
                "has_employees": data.has_employees,
                "has_technicians": data.has_technicians,
                "has_supervisors": data.has_supervisors,
                "has_engineers": data.has_engineers,
                "has_executives": data.has_executives,
                "has_others": data.has_others,
                "has_others_name": data.has_others_name,
                "mandate_years": data.mandate_years,
                "carency_round_one": ((data.carency_round_one === true) ? data.date_round_one : null),
                "election_round_one": data.election_round_one,
                "carency_round_two": ((data.carency_round_two === true) ? data.date_round_two : null),
                "election_round_two": data.election_round_two,
                "userId": data.userId,
                "extraSiret": data.extraSiret,
                "assessors_1": data.assessors_1,
                "assessors_2": data.assessors_2
            };
            if (data.carency_round_one && data.date_round_one !== undefined && electionId.length === 0) { electionId = 'carence'; }
            saveCseElection(accessToken, electionId, form).then((result) => {
                setLoading(false);
                console.log("result", result);
                toast.success('Election CSE sauvegardée !');
                setResults(result.data);
            }).catch((error) => {
                setLoading(false);
                console.log("error", error);
                toast.error('Erreur lors de la sauvegarde de l\'élection CSE : ' + error);
            });
        } else {
            toast.error(`Il faut au moins un identifiant d'élection  !`);
        }
    }

    //extra US
    const [showUS, setShowUS] = useState(false);

    //infos entreprise
    const [showCompany, setShowCompany] = useState(true);
    const [siret, setSiret] = useState("");
    const [companyName, setCompanyName] = useState("");
    useEffect(() => {
        const formattedSiret = siret.replace(/\s/g, '');
        if (formattedSiret.length === 14) {
            getCompanyInfos(formattedSiret)
        }
    }, [siret]);
    const getCompanyInfos = async (siret) => {
        console.log("getCompanyInfos", siret);
        const accessToken = await getAccessTokenSilently();
        const {data, error} = await getCompanyForSiret(accessToken, siret);

        console.log("getCompanyInfos", data, error);
        if (data) {
            setCompanyName(data.name)
            setValue("siret", data.siret)
            setValue("name", data.name)
            setValue("address1", data.address1)
            setValue("address2", data.address2)
            setValue("postalCode", data.postalCode)
            setValue("city", data.city)
            setValue("colleges", data.colleges)
            setValue("idcc", data.idcc)
            setValue("contactFirstName", data.contactFirstName)
            setValue("contactLastName", data.contactLastName)
            setValue("contactRole", data.contactRole)
            setValue("contactPhone", data.contactPhone)
            setValue("contactEmail", data.contactEmail)
            setValue("lastElection", new Date(data.lastElection).toISOString().substring(0, 10))
            setValue("userId", data.userId)
            toast.success('Entreprise chargée', {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        if (error) {
            toast.error('Entreprise non trouvée : ' + error)
        }
    }

    //1er tour
    const [carenceRound1, setCarenceRound1] = useState(false);

    //2e tour
    const [carenceRound2, setCarenceRound2] = useState(false);

    const [showOthers, setShowOthers] = useState(false);


    function onCompanySelect(event) {
        setValue("siret", event);
        if (event.length === 14) {
            getCompanyInfos(event)
        }
    }

    useEffect(() => {
        async function fetchCompanies() {
            const accessToken = await getAccessTokenSilently();
            const { data, error } = await getCompanies(accessToken);
            const results = [];
            // Store results in the results array
            data.forEach((value) => {
                results.push({
                    key: value.second,
                    value: value.first + ' - ' + value.second
                });
            });

            setOptions([
                {key: 'Select a company', value: ''},
                ...results
            ])
        }
        fetchCompanies();
    }, []);

    return (
        <PageLayout>
            {loading ? (
                <div className="loader-container">
                    <div className="spinner"></div>
                </div>
            ) : (
                <div className="content-layout">
                    <h1 id="page-title" className="content__title">
                        Organisation CSE
                    </h1>
                    <div className="content__body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <p id="page-description">
                        <span>
                            Configurer l'organisation du CSE.
                        </span>
                            </p>
                            <p>
                                <div>
                                    <button onClick={() => setShowCompany(!showCompany)}>{showCompany &&
                                        <span>-</span>}{!showCompany && <span>+</span>}</button>
                                    &nbsp;
                                    Entreprise <strong>{companyName}</strong>
                                </div>
                                <div className="tip">
                                    Tapez le numero de SIRET pour compléter les informations de l'entreprise.
                                </div>
                            </p>
                            {showCompany &&
                                <div>
                                    <div className="">
                                        {
                                            <DropdownButton
                                              id={`dropdown-variants}`}
                                              title='Select existing company'
                                              onSelect={onCompanySelect}
                                            >
                                                {options.map(
                                                  (variant) => (
                                                    <Dropdown.Item eventKey={variant.key}>{variant.value}</Dropdown.Item>
                                                  ))}
                                            </DropdownButton>
                                        }
                                        <br/>
                                        <div className="row">
                                            <div className="column left">
                                                <span>Numero siret: </span>
                                            </div>
                                            <div className="column right">

                                                <input placeholder="Siret (14 chiffres)"
                                                       size="14" style={{width: "9em"}}
                                                       {...register("siret", {
                                                           required: true,
                                                           minLength: 14,
                                                           maxLength: 14
                                                       })}
                                                       onChange={(event) => setSiret(event.target.value)}
                                                />
                                                {errors.siret && <p className="error">Siret must 14 characters long</p>}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="column left">
                                                <span>Nom de l'entreprise: </span>
                                            </div>
                                            <div className="column right">
                                                <input {...register("name", {})}
                                                       style={{width: "12em"}}
                                                       placeholder="nom"/>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="column left">
                                                <span>Addresse : </span>
                                            </div>
                                            <div className="column">
                                                <input {...register("address1", {})}
                                                       style={{width: "15em"}}
                                                       placeholder="addresse"/>
                                                <div className="row">
                                                    <div className="column">
                                                    </div>
                                                    <div className="column">
                                                        <input {...register("address2", {})}
                                                               style={{width: "15em"}}
                                                               placeholder="addresse (suite)"/>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="column left">
                                                <span>Code Postal et ville : </span>
                                            </div>
                                            <div className="column right">
                                                <input size="5" style={{width: "6em"}}
                                                       type="number" {...register("postalCode", {})}
                                                       placeholder="code"/>
                                                <input {...register("city", {})}
                                                       style={{width: "12em"}}
                                                       placeholder="Ville"/>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="column left">
                                                <span>Contact : </span>
                                            </div>
                                            <div className="column right">
                                                <input
                                                    {...register("contactFirstName", {})}
                                                    style={{width: "8em"}}
                                                    placeholder="Prénom"
                                                />
                                                <input
                                                    {...register("contactLastName", {})}
                                                    style={{width: "14em"}}
                                                    placeholder="Nom"
                                                />
                                                <div className="column right">
                                                    <input
                                                        {...register("contactRole", {})}
                                                        style={{width: "14em"}}
                                                        placeholder="rôle"
                                                    />
                                                    <div className="column right">
                                                        <input
                                                            {...register("contactEmail", {})}
                                                            style={{width: "14em"}}
                                                            placeholder="email"
                                                        />
                                                        <div className="column right">
                                                            <input
                                                                {...register("contactPhone", {})}
                                                                style={{width: "14em"}}
                                                                placeholder="téléphone"
                                                            />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="column left">
                                                <span>Nombre de collèges : </span>
                                            </div>
                                            <div className="column right">
                                                <input size="2" style={{width: "3em"}}
                                                       type="number" {...register("colleges", {})} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="column left">
                                                <span>Dernière élection CSE : </span>
                                            </div>
                                            <div className="column right">
                                                <input
                                                    type="date" {...register("lastElection", {setValueAsDate: true,})}
                                                    placeholder="01/01/2021"
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="column left">
                                                <span>Identifiant convention collective : </span>
                                            </div>
                                            <div className="column right">
                                                <input size="5" style={{width: "6em"}}
                                                       {...register("idcc", {})} />
                                                <a href="https://travail-emploi.gouv.fr/dialogue-social/negociation-collective/article/conventions-collectives-nomenclatures"
                                                   target="new">(référentiel)</a>
                                            </div>
                                        </div>


                                        {/*<p><i>Facultatifs : </i></p>*/}

                                        {/*<div className="row">*/}
                                        {/*    <div className="column left">*/}
                                        {/*        <span>Id utilisateur : </span>*/}
                                        {/*    </div>*/}
                                        {/*    <div className="column right">*/}
                                        {/*        <input {...register("userId", {})}*/}
                                        {/*               placeholder="12345..."*/}
                                        {/*        />*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                    </div>
                                </div>
                            }

                            {/*Election*/}
                            <hr/>
                            <p>
                                <div>
                                    Election
                                </div>
                                <div className="tip">
                                    <i>Les informations ci-dessous permettent de pré-remplir les informations de
                                        l'élection.</i>
                                </div>
                            </p>
                            <div>
                                <div className="row">
                                    <div className="column left">
                                        <span>Nombre de sieges à pourvoir:</span>
                                    </div>
                                    <div className="column right">
                                        <input placeholder="sieges"
                                               size="3" style={{width: "4em"}}
                                               {...register("seats")}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column left">
                                        <span>Election partielle ?</span>
                                    </div>
                                    <div className="column right">
                                        <input type="checkbox"
                                               {...register("is_partial")}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column left">
                                        <span>Type de collège:</span>
                                    </div>
                                    <div className="column right">
                                        <select {...register("college")}>
                                            <option value="UNIQUE">Unique</option>
                                            <option value="ONE">1er collège: ouvriers, employés</option>
                                            <option value="TWO">2eme collège: techniciens, ingénieurs, ...</option>
                                            <option value="THREE">3eme collège: ingénieurs et cadres</option>
                                            <option value="OTHER">Autre collège</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column left">
                                        <span>Composition du collège</span>
                                    </div>
                                    <div className="column right">
                                        <div className="row">
                                            <div className="column left">
                                                Ouvriers
                                            </div>
                                            <div className="column right">
                                                <input type="checkbox"
                                                       {...register("has_workers")}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="column left">
                                                Employés
                                            </div>
                                            <div className="column right">
                                                <input type="checkbox"
                                                       {...register("has_employees")}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="column left">
                                                Techniciens
                                            </div>
                                            <div className="column right">
                                                <input type="checkbox"
                                                       {...register("has_technicians")}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="column left">
                                                Agents de maîtrise
                                            </div>
                                            <div className="column right">
                                                <input type="checkbox"
                                                       {...register("has_supervisors")}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="column left">
                                                Ingénieurs
                                            </div>
                                            <div className="column right">
                                                <input type="checkbox"
                                                       {...register("has_engineers")}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="column left">
                                                Cadres
                                            </div>
                                            <div className="column right">
                                                <input type="checkbox"
                                                       {...register("has_executives")}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="column left">
                                                Autres (préciser)
                                            </div>
                                            <div className="column right">
                                                <input type="checkbox"
                                                       {...register("has_others")}
                                                       onChange={(event) => setShowOthers(event.target.checked)}
                                                />
                                                {showOthers &&
                                                <input placeholder="Ex: journalistes, pilotes,..."
                                                       //size="10" //style={{width: "4em"}}
                                                       {...register("has_others_name")}
                                                />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column left">
                                        <span>Durée du mandat</span>
                                    </div>
                                    <div className="column right">
                                        <input type="number" min="1" max="9" placeholder=""
                                               size="1" style={{width: "2em"}}
                                               {...register("mandate_years")}
                                        /> ans
                                    </div>
                                </div>
                            </div>

                            {/* 1er tour */}
                            <p>
                                <div>
                                    1er tour
                                </div>
                                <div className="tip">

                                </div>
                            </p>
                            <div>
                                <div className="row">
                                    <div className="column left">
                                        <span>Carence de candidats ?</span>
                                    </div>
                                    <div className="column right">
                                        <input type="checkbox" {...register("carency_round_one", {})}
                                               onChange={(event) => setCarenceRound1(event.target.checked)}
                                        />
                                    </div>
                                </div>
                                {carenceRound1 &&
                                    <div className="">
                                        <div className="row">
                                            <div className="column left">
                                                <span>Date du premier tour</span>
                                            </div>
                                            <div className="column right">
                                                <input
                                                    type="date" {...register("date_round_one", {setValueAsDate: true,})}/>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="column left">
                                                <span>Identifiant d'élection:</span>
                                            </div>
                                            <div className="column right">
                                                <input placeholder="Liste des assesseurs, separees par virgule et espace"
                                                       style={{width: "40em"}}
                                                       {...register("assessors_1")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }
                                {!carenceRound1 &&
                                    <div className="">
                                        <div className="row">
                                            <div className="column left">
                                                <span>Identifiant d'élection:</span>
                                            </div>
                                            <div className="column right">
                                                <input placeholder="Identifiant election"
                                                       size="32" style={{width: "16em"}}
                                                       {...register("election_round_one", {
                                                           minLength: 36,
                                                           maxLength: 36
                                                       })}
                                                />
                                                {errors.election_round_one &&
                                                    <p className="error">L'identifiant d'election doit être de 14
                                                        caractères</p>}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>

                            {/* 2e tour */}
                            <p>
                                <div>
                                    2eme tour
                                </div>
                                <div className="tip">

                                </div>
                            </p>
                            <div>
                                <div className="row">
                                    <div className="column left">
                                        <span>Carence de candidats ?</span>
                                    </div>
                                    <div className="column right">
                                        <input type="checkbox" {...register("carency_round_two", {})}
                                               onChange={(event) => setCarenceRound2(event.target.checked)}
                                        />
                                    </div>
                                </div>
                                {carenceRound2 &&
                                    <div className="">
                                        <div className="row">
                                            <div className="column left">
                                                <span>Date du deuxième tour</span>
                                            </div>
                                            <div className="column right">
                                                <input
                                                    type="date" {...register("date_round_two", {setValueAsDate: true,})}/>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="column left">
                                                <span>Identifiant d'élection:</span>
                                            </div>
                                            <div className="column right">
                                                <input placeholder="Liste des assesseurs, separees par virgule et espace"
                                                       style={{width: "40em"}}
                                                       {...register("assessors_2")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }
                                {!carenceRound2 &&
                                    <div className="">
                                        <div className="row">
                                            <div className="column left">
                                                <span>Identifiant d'élection:</span>
                                            </div>
                                            <div className="column right">
                                                <input placeholder="Identifiant election"
                                                       size="32" style={{width: "16em"}}
                                                       {...register("election_round_two", {
                                                           minLength: 36,
                                                           maxLength: 36
                                                       })}
                                                />
                                                {errors.election_round_two &&
                                                    <p className="error">L'identifiant d'election doit être de 14
                                                        caractères</p>}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>


                            <p>
                                <div>
                                    <button onClick={() => setShowUS(!showUS)}>{showUS &&
                                      <span>-</span>}{!showUS && <span>+</span>}</button>&nbsp;
                                    Extra US
                                </div>
                                <div className="tip">
                                    Tapez les numeros des extra SIRET s'il y a plusieurs.
                                </div>
                            </p>
                            { showUS && <div>
                                <div className="row">
                                    <div className="column left">
                                        <span>Codes extra Siret: </span>
                                    </div>
                                    <div className="column right">
                                        <textarea className="large-textarea" {...register("extraSiret", {required: false})} />
                                    </div>
                                </div>
                            </div>
                            }
                            <div className="row">
                                <p><input type="submit" className="button button--compact button--primary" value="GENERER LE CERFA"/></p>
                            </div>
                        </form>

                        {results && Object.keys(results).length > 0 &&
                            <div>
                                <p>Results</p>
                                {Object.entries(results).map(([name, link]) => {
                                    return <p><a style={{"text-decoration": "underline"}} href={link}
                                                 target="new">{name}</a></p>
                                })}
                            </div>
                        }
                    </div>
                </div>
            )}
        </PageLayout>
    );
};
